import { HeaderDiv, Title } from './style'

const Header = ({ title }) => {
  return (
    <HeaderDiv>
      <Title>{title}</Title>
    </HeaderDiv>
  )
}
export default Header
